<template>
  <!-- DeepSea Navigation Bar -->
  <div class="navigation-bar" id="deepsea-nav-bar">
    <div class="nav-bar-content">
      <!-- DeepSea Logo -->
      <div class="logo" id="deepsea-logo">
        <a class="block" href="https://deepseasandbox.wpenginepowered.com/"></a>
      </div>
      <!-- DeepSea Desktop Navigation -->
      <DesktopNav v-if="!mobileView" :deepsea="true" />
      <!-- DeepSea Mobile Icon -->
      <button
        v-if="mobileView"
        class="nav-icon"
        @click="showMobileNav = !showMobileNav"
      >
        <font-awesome-icon class="menu fa-lg" icon="bars" />
      </button>
      <!-- DeepSea Mobile Navigation -->
      <Transition name="slide-fade">
        <MobileNav
          v-if="showMobileNav"
          v-click-away="onClickAway"
          :deepsea="true"
        />
      </Transition>
    </div>
  </div>
</template>

<script>
import MobileNav from '@/components/MobileNav.vue'
import DesktopNav from '@/components/DesktopNav.vue'
import { directive } from 'vue3-click-away'

export default {
  name: 'DeepSea Navigation',
  components: {
    MobileNav,
    DesktopNav,
  },
  data() {
    return {
      mobileView: false,
      showMobileNav: false,
    }
  },
  directives: {
    ClickAway: directive,
  },
  methods: {
    onClickAway(event) {
      console.log(event)
      this.showMobileNav = false
    },
    handleView() {
      this.mobileView = window.innerWidth <= 1355
    },
  },
  mounted() {
    this.handleView()
    window.addEventListener('resize', this.handleView, { passive: true })
  },
}
</script>

<style scoped>
/* Mobile First */
.navigation-bar {
  padding: 0 16px;
}

.nav-bar-content {
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

#deepsea-logo {
  background-image: url('../assets/images/logo-deepsea.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
  height: 46px;
  max-width: 200px;
  margin: 0px;
}

@media screen and (min-width: 425px) {
  .navigation-bar {
    padding: 0 32px;
  }

  #deepsea-logo {
    max-width: 250px;
  }
}
</style>
